<mat-sidenav mode="over" class="" position="end">
  <h1>Test</h1>
</mat-sidenav>